/** OIDC `groups` claim value of the R&D group. */
export const RND_USER_GROUP = 'aadrnd';

/**
 * Groups allowed on the trading-management restricted surfaces: the `settings`/`tnt`
 * route guards, the restricted menu items, and the create/edit-loan trading-desk behavior.
 */
export const ELEVATED_USER_GROUPS = ['tradingManagement', RND_USER_GROUP] as const;

/**
 * True when any of the user's OIDC groups is elevated. Tolerates a missing list —
 * OIDC init can fail and leave `userGroups` unassigned.
 */
export const isElevatedUserGroupMember = (userGroups: readonly string[] | undefined | null): boolean =>
  userGroups?.some((group) => ELEVATED_USER_GROUPS.some((allowed) => allowed === group)) ?? false;
